import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ExpenseEditionFormWrapper } from 'src/Components/Forms/Expense/ExpenseEditionFormWrapper';

type ExpenseParams = {
  expenseId: string;
};

const EditExpenseDrawer = () => {
  const { t } = useTranslation();
  const { expenseId } = useParams<ExpenseParams>();

  if (!expenseId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('expenses.editExpense', "Modifier l'opération")}>
      {({ onClose }) => (
        <ExpenseEditionFormWrapper onCreate={onClose} onCancel={onClose} expenseId={expenseId} />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default EditExpenseDrawer;
